export default __webpack_public_path__ + "static/media/add-orange-icon.41fcf85f.svg";